export default "__VITE_ASSET__BmqtG4DX__"